import { createSlice } from '@reduxjs/toolkit';
import db from '../../hooks/useFirebase';
import { v1 as uuid } from 'uuid';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: false,
  videoTemplatesList: [],
};

const slice = createSlice({
  name: 'list',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    // GET MANAGE Messages
    getVideoTemplatesListSuccess(state, action) {
      state.isLoading = false;
      state.videoTemplatesList = action.payload;
    },
  }
});

// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------

export function getVideoTemplatesList() {
    return async (dispatch) => {
      dispatch(slice.actions.startLoading());
      try {
        let initialQuery = await db.firestore().collection('offers_templates').where("status","!=","deleted").limit(1000);
        let documentSnapshots = await initialQuery.get();
        let documentData = documentSnapshots.docs.map(document => document.data());

        dispatch(slice.actions.getVideoTemplatesListSuccess(documentData));
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
}

export async function getVideoTemplate(uid) {
    try {
      let templateChooseQuery = await db.firestore().collection('offers_templates').doc(uid).get()

      const fetchedData = []
      await db.firestore().collection('offers_templates').doc(uid).collection('questions').get().then(response => {
          response.forEach(document => {
              let fetched = {
                  ...document.data()
              };
              fetchedData.push(fetched);
          });
      });

      let data = []

      fetchedData.sort(function (a, b) {
        let numA = parseInt(a.position)
        let numB = parseInt(b.position)
        if (numA > numB) {
          return 1;
        }
        if (numA < numB) {
          return -1;
        }
        return 0;
      });
      data.list = fetchedData
      data.view = templateChooseQuery.data()

      return data

    } catch (error) {
      console.log(error)
    }
}

export async function dellVideoTemplate(uid) {
    try {
      // await db.firestore().collection('offers_templates').doc(uid).set({status: "deleted"})
      await db.firestore().collection('offers_templates').doc(uid).delete()

      return true
    } catch (error) {
      console.log(error)
    }
}

export async function updateVideoTemplate(uid,view,data,old_data) {
    try {
      if(!uid) {
        uid = uuid()
      }

      if(view.isbase==true) {
        await db.firestore().collection('offers_templates').where("isbase","==",true).get().then(response => {
            response.forEach(document => {
                let doc = document.data()
                doc.isbase = false
                db.firestore().collection('offers_templates').doc(doc.uid).set(doc)
            });
        });
      }

      let viewData = {
        avatar: "base",
        company: "asystent.biz",
        isbase: view.isbase,
        message: view.message,
        text: view.fulltext,
        uid: uid,
        status: "active",
      }
      
      await db.firestore().collection('offers_templates').doc(uid).set(viewData)

      //удаляем старые записи вопросов
      let docis = await db.firestore().collection('offers_templates').doc(uid).collection('questions').get()
      let documentsData = docis.docs.map(document => document.data());
      documentsData.map(async (val) => {
        await db.firestore().collection('offers_templates').doc(uid).collection('questions').doc(val.id).delete()
      })

      //добавляем новые записи вопросов
      data.map((item)=>{
        sleep(10);
        let id = Date.now()
        if(item.id>0 && item.id<100) {
          item.id = id.toString()
        }

        try {
          db.firestore().collection('offers_templates').doc(uid).collection('questions').doc(item.id).set(item)
        } catch (error) {
          console.error(error);
        }
      })
      
      return true
    } catch (error) {
      console.log(error)
    }
}

function sleep(milliseconds) {
  const date = Date.now();
  let currentDate = null;
  do {
    currentDate = Date.now();
  } while (currentDate - date < milliseconds);
}